import { render, staticRenderFns } from "./interface.vue?vue&type=template&id=766e9fe1&scoped=true&lang=html"
import script from "./interface.vue?vue&type=script&lang=js"
export * from "./interface.vue?vue&type=script&lang=js"
import style0 from "./interface.vue?vue&type=style&index=0&id=766e9fe1&prod&lang=css"
import style1 from "./interface.vue?vue&type=style&index=1&id=766e9fe1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e9fe1",
  null
  
)

export default component.exports